export enum PropertyType {
  MULTI_FAMILY = '500000704284',
  RESIDENTIAL_LEASE = '500000704754',
  FARM = '500000704852',
  COMMERCIAL_LEASE = '500000705144',
  LAND = '500000705330',
  RESIDENTIAL = '500000705622',
  COMMERCIAL_SALE = '500000706106',
}
export enum PropertyTypeNames {
  MULTI_FAMILY = 'Multi-Family',
  RESIDENTIAL_LEASE = 'Residential Lease',
  FARM = 'Farm',
  COMMERCIAL_LEASE = 'Commercial Lease',
  LAND = 'Land',
  BUSINESS_OPPORTUNITY = 'Business Opportunity',
  RESIDENTIAL = 'Residential',
  COMMERCIAL_SALE = 'Commercial Sale',
}

export function getPropertyTypeKey(
  value: PropertyType,
): keyof typeof PropertyType | undefined {
  return (Object.keys(PropertyType) as Array<keyof typeof PropertyType>).find(
    (key) => PropertyType[key] === value,
  );
}

export function isResidentalListing(
  value: { value: string } | string | undefined,
): boolean {
  if (!value) {
    return false;
  }
  if (value.hasOwnProperty('value')) {
    // Provided value is a container (from FLC) -- unpack
    return isResidentalListing((value as { value: string }).value);
  }

  // RES, RESI, RESL -- match any property types targeting residental listings
  return `${value}`.includes(PropertyTypeNames.RESIDENTIAL);
}
